export default {
  computed: {
    allCallToActions: function () {
      return this.$store.state.CallToActionStore.all_call_to_actions
    }
  }
}
